<template>
	<v-row class="headerBlock"
		:style="'height: ' + headerHeight + 'px; padding-top: ' + headerPadding + 'px; background-color: ' + (bgcolor ?? '#FBF7F4dd') + '; border-bottom: ' + (border ?? '1') + 'px solid var(--border-color);' + (transparent ? 'background-color: transparent; border-bottom: none;' : '') ">
		<v-col :class="['left-col', (favoritesIcon && voucherIcon) ? 'v-col-3' : 'v-col-2']">
			<div v-if="allowBack && !escapeRoute && !logicalBack" class="mg-circle-icon-button" @click="handleBack();">
				<img :src="require('@/assets/arrow-left.svg')" alt="Back" :class="['back-arrow-icon', { 'white-arrow': color === 'white' }]" />
			</div>
			<div v-if="allowBack && !escapeRoute && logicalBack" class="mg-circle-icon-button" @click="if (logicalBack) { handleLogicalBack(); }">
				<img :src="require('@/assets/arrow-left.svg')" alt="Back" :class="['back-arrow-icon', { 'white-arrow': color === 'white' }]" />
			</div>
		</v-col>
		<v-col class="title" :style="'color: ' + (color ?? 'black')">{{ title }}
			<slot />
		</v-col>
		<v-col :class="['right-col', (favoritesIcon && voucherIcon) ? 'v-col-3' : 'v-col-2']">
			<v-app-bar-nav-icon v-if="settingsMenu" class="menu-button"
				@click="toggleSettingsDrawer"></v-app-bar-nav-icon>
			<div v-if="mgChat && !voucherIcon && !escapeRoute" class="mg-chat-button">
				<ChatMgButton :prompt="mgChat" :hover="false" />
			</div>
			<img v-if="favoritesIcon" :class="favoritesIcon && voucherIcon ? 'mg-smaller-circle-image-button' : 'mg-circle-image-button'" :src="require('@/assets/heart.png')"
				@click="$router.push('/FavoriteVouchers')" />
			<img v-if="voucherIcon" :class="favoritesIcon && voucherIcon ? 'mg-smaller-circle-image-button' : 'mg-circle-image-button'" :src="require('@/assets/credit-card.png')"
				@click="$router.push('/Wallet')" />
			<img v-if="addButton" class="mg-circle-image-button" :src="require('@/assets/plus-inverted.png')" @click="$router.push('/shopvouchers')" />
			<div v-if="escapeRoute && !$route.query.inModal" class="mg-circle-icon-button" @click="goEscape"><v-icon
					icon="mdi-close" /></div>
			<div v-if="edit && !del" class="mg-circle-icon-button" @click="onEditPressed"><v-icon icon="mdi-pencil" />
			</div>
			<div v-if="del && !edit" class="mg-circle-icon-button" @click="showDelete = true;"><v-icon
					icon="mdi-delete" /></div>
			<v-menu v-if="del && edit">
				<template v-slot:activator="{ props }">
					<div v-bind="props" class="mg-circle-icon-button">
						<v-icon :icon="'mdi-menu'" :color="color === 'white' ? 'white' : undefined" />
					</div>
				</template>
				<v-list>
					<v-list-item>
						<div v-bind="props" class="mg-circle-icon-button" @click="onEditPressed"><v-icon
								icon="mdi-pencil" /></div>
						<div v-bind="props" class="mg-circle-icon-button" @click="showDelete = true;"><v-icon
								icon="mdi-delete" /></div>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-col>
	</v-row>

	<AppSettingsDrawer v-if="settingsMenu" ref="settingsDrawer" @close="toggleSettingsDrawer" />

	<v-dialog max-width="500" v-if="showDelete" v-model="showDelete">
		<v-card>
			<v-card-title />
			<v-card-text>Are you sure you want to delete "{{ title }}"?</v-card-text>
			<v-card-actions class="justify-center">
				<div class="d-flex flex-column align-center">
					<MGButton :fullWidth="true" @click="$emit('delete')" text="Delete" />
					<MGButton :stacked="true" :fullWidth="true" @click="showDelete = false" :outline="true"
						text="Cancel" />
				</div>
			</v-card-actions>
		</v-card>
	</v-dialog>

</template>

<script>
import AppSettingsDrawer from './AppSettingsDrawer.vue';
import ChatMgButton from './ChatMgButton.vue';
import MGButton from './MGButton.vue';

export default {
	name: "HeaderBlock",
	props: {
		title: { type: String, required: true },
		color: { type: String, default: "black" },
		bgcolor: { type: String, default: "#FBF7F4dd" },
		border: { type: String, default: "1" },
		edit: { type: Boolean, default: false },
		del: { type: Boolean, default: false },
		logicalBack: { type: Boolean, default: false },
		transparent: { type: Boolean, default: false }
	},
	emits: ['delete', 'edit', 'back', 'logicalBack'],
	components: { ChatMgButton, AppSettingsDrawer, MGButton },
	data() {
		return {
			escapeRoute: null,
			allowBack: false,
			showDelete: false,
			favoritesIcon: false,
			mgChat: false,
			settingsMenu: false,
			voucherIcon: false,
			addButton: false
		}
	},
	computed: {
		safeTop() {
			return parseInt(this.$cookies.get('st') ?? 0);
		},
		headerHeight() {
			return 56 + this.safeTop;
		},
		headerPadding() {
			return 4 + this.safeTop;
		}
	},
	methods: {
		onLoad() {
			this.settingsMenu = this.$route.meta.showSettings;
			this.voucherIcon = this.$route.meta.showVoucherIcon;
			this.favoritesIcon = this.$route.meta.showFavoritesIcon;
			this.mgChat = this.$route.meta.aiChat;
			this.escapeRoute = this.$route.meta.escapeRoute;
			if (this.escapeRoute == null || this.escapeRoute == undefined) {
				this.escapeRoute = this.$route.query.escapeRoute;
			}
			this.allowBack = this.$route.meta.allowBack ?? true;
			this.addButton = this.$route.meta.addButton ?? false;
		},
		goEscape() {
			if (this.escapeRoute == '<') this.$router.go(-1);
			else
				this.$router.push({ path: '/' + this.escapeRoute, replace: true });
		},
		toggleSettingsDrawer() {
			this.$refs.settingsDrawer.toggle();
		},
		onEditPressed() {
			this.$emit('edit');
			if (this.edit && typeof this.edit === 'string') {
				this.$router.push(this.edit);
			}
		},
		handleBack() {
			if (this.$route.meta.overrideBack) {
				this.$router.push(this.$route.meta.overrideBack);
			}
			else
			{
				this.$router.back();
			}
		},
		handleLogicalBack() {
			this.$emit('logicalBack');
		}
	},
	mounted: function () { this.onLoad(); }
}
</script>

<style scoped>
.headerBlock {
	height: 56px;
	padding-top: 4px;
	b--order-top: 1px solid red;
	border-bottom: 1px solid var(--border-color);
	margin-bottom: 20px;
	margin-left: -30px;
	margin-right: -30px;

	position: sticky;
	top: 0;
	width: 100vw;
	z-index: 100;
	/* background-color: var(--background-color-alt); */
}

.title {
	font-size: 15px;
	text-align: center;
}

.right-col {
	text-align: right;
}

.mg-circle-icon-button {
	/* background-color: var(--text-color); */
	border-radius: 50% !important;
	height: 33px !important;
	width: 33px !important;
	padding-top: 7px !important;
	text-align: center;
	margin-top: -5px;
	font-size: 12px;
}

.back-arrow-icon {
	width: 22px;
	height: 16px;
	display: block;
	margin: 0 auto;
}

.white-arrow {
	filter: brightness(0) invert(1);
}

.mg-smaller-circle-image-button {
	background-color: #ffffff77;
	/* background-color: var(--text-color); */
	border-radius: 50% !important;
	height: 28px !important;
	width: 28px !important;
	padding: 5px;
	text-align: center;
	margin-top: 0px;
	font-size: 12px;
	background-position: center;
}

.mg-circle-image-button {
	/* background-color: var(--text-color); */
	border-radius: 50% !important;
	height: 33px !important;
	width: 33px !important;
	padding: 5px;
	text-align: center;
	margin-top: -5px;
	font-size: 12px;
	background-position: center;
}

.mg-chat-button {
	border-radius: 50% !important;
	height: 40px !important;
	width: 40px !important;
	margin-top: -5px;
}

.menu-button {
	/* p--osition: absolute;
	t--op: 5px;
	l--eft: 5px;
	z--index: 1000;
	opacity: 0.8;
	transition: opacity 0.3s;
	background-color: var(--background-color);
	border-radius: 50%;
	padding: 4px;
	transform: scale(0.8); */

	height: 40px !important;
	width: 40px !important;
	margin-top: -8px;
}

.menu-button :deep(.v-icon) {
	font-size: 20px;
}

.menu-button:hover {
	opacity: 1;
}

/* Hide menu button when drawer is open */
.v-navigation-drawer--active+.menu-button {
	display: none;
}

/* Adjust drawer height to fit between header and menu bar */

/* Make v-card-actions fill full width */
:deep(.v-card-actions) {
	width: 100% !important;
	padding: 16px !important;
}

:deep(.v-card-actions .d-flex) {
	width: 100% !important;
}

/* Make buttons in dialog full width */
:deep(.v-dialog .v-card-actions .mg-button) {
	width: 100% !important;
}

:deep(.v-dialog .v-card-actions button) {
	width: 100% !important;
}

/* Make v-card components have rounded corners */
:deep(.v-card) {
	border-radius: 16px !important;
}
</style>